import { AsyncPipe, DatePipe, KeyValuePipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { AlertsPageRoutingModule } from './alerts-routing.module';
import { AlertsPageComponent } from './alerts.component';

@NgModule({
  declarations: [AlertsPageComponent],
  imports: [AlertsPageRoutingModule, IonicModule, TitleCasePipe, KeyValuePipe, MiscModule, DatePipe, AsyncPipe]
})
export class AlertsPageModule {}
